import { useCallback, useState } from 'react';

import { STORAGE_KEYS } from '@constants/index';
import { useLocalStorage } from './useLocalStorage';

interface UseSidebarReturn {
  /** Desktop icon-rail mode (persisted across sessions). */
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
  toggle: () => void;
  /** Mobile off-canvas drawer open state (transient — not persisted). */
  mobileOpen: boolean;
  openMobile: () => void;
  closeMobile: () => void;
}

export function useSidebar(): UseSidebarReturn {
  const [collapsed, setCollapsed] = useLocalStorage<boolean>(STORAGE_KEYS.sidebarCollapsed, false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggle = useCallback(() => setCollapsed(!collapsed), [collapsed, setCollapsed]);
  const openMobile = useCallback(() => setMobileOpen(true), []);
  const closeMobile = useCallback(() => setMobileOpen(false), []);

  return { collapsed, setCollapsed, toggle, mobileOpen, openMobile, closeMobile };
}
